/* ============================================================
   MC LOOKBOOK — "Our Looks" showcase (reference .lookbook)
   ============================================================
   Syncs the active "look" across: the crossfading background
   lifestyle image (stage), the product card panes (default/hover),
   the badge, the add-to-cart host, the info panel, and the dots.
   Prev/next + dots navigate. Swatches are a decorative active state.
   Add-to-cart itself is Horizon's native quick-add (cart drawer).
   ============================================================ */
(function () {
  'use strict';

  function initOne(root) {
    if (root.dataset.mcLookbookReady === 'true') return;
    root.dataset.mcLookbookReady = 'true';

    var indexed = Array.prototype.slice.call(root.querySelectorAll('[data-look]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.mc-lookbook__dot'));
    var count = parseInt(root.dataset.mcLookbookCount || '0', 10) || dots.length;
    if (!count) return;

    var prevBtn = root.querySelector('[data-mc-lookbook-prev]');
    var nextBtn = root.querySelector('[data-mc-lookbook-next]');
    var index = 0;

    function set(i) {
      index = ((i % count) + count) % count;
      for (var n = 0; n < indexed.length; n++) {
        var el = indexed[n];
        el.classList.toggle('is-active', parseInt(el.dataset.look, 10) === index);
      }
      // Mirror the visual state onto the dots for assistive tech (4.1.2).
      // aria-current is removed rather than set to "false" — "false" is valid
      // but screen readers treat absence as the clearer signal.
      dots.forEach(function (dot) {
        if ((parseInt(dot.dataset.look, 10) || 0) === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        set(parseInt(dot.dataset.look, 10) || 0);
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { set(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { set(index + 1); });

    // Keyboard: arrow keys when focus is inside the body
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { set(index - 1); }
      else if (e.key === 'ArrowRight') { set(index + 1); }
    });

    // Decorative swatch active state (does not change the image)
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('.mc-lookbook__swatch');
      if (!sw) return;
      var group = sw.closest('.mc-lookbook__swatches');
      if (!group) return;
      group.querySelectorAll('.mc-lookbook__swatch').forEach(function (s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      sw.classList.add('is-active');
      sw.setAttribute('aria-pressed', 'true');
    });

    // Theme editor: when a "look" block is selected, show it
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      var dot = root.querySelector('.mc-lookbook__dot[data-block-id="' + id + '"]');
      if (dot) set(parseInt(dot.dataset.look, 10) || 0);
    });

    set(0);
  }

  function init() {
    document.querySelectorAll('[data-mc-lookbook]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init sections added in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
